// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GeoRegionStateMapper from "../entity-mapper/GeoRegionStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = GeoRegionStateMapper.builder;

var GeoRegionRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var GeoRegionResponseConverter = partial_arg(GeoRegionRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  GeoRegionRepoConfig ,
  GeoRegionResponseConverter ,
  
}
/* GeoRegionResponseConverter Not a pure module */
